import './HeroLayoutHrThree.css';
import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, convertEpochTime, getImageId, fetchAnchorValue } from '../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import bcrypt from 'bcryptjs-react';

HeroLayoutHrThree.version = 1000;

HeroLayoutHrThree.lang = 'en';
HeroLayoutHrThree.langs = [
  'en'
];
HeroLayoutHrThree.setLang = (lang: any) => {
  HeroLayoutHrThree.lang = lang;
}

Object.defineProperty(HeroLayoutHrThree, 'name', {
  writable: true,
  value: 'HeroLayoutHrThree'
});

export function HeroLayoutHrThree(props: any) {

  const { anchorLinksValue } = props;

  let styles = require("./HeroLayoutHrThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("HeroLayoutHrThree", styles);
  const endpoint = getEndpoint(props);
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint, props.showAdSlot]);

  const setItemsObj = (response: any) => {
    setItems(response.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
    && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }



  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    let componentID = getID(props.data);
   
    return <CacheProvider value={getMUICache()}>
      <div id={componentID}>
      {/* style={{ backgroundColor: props.BgColor }} */}
        <div className='commoncontainer'>
          <Grid className='masterHeroLayoutHorizontal'>
            <div className='themeTwoRightsideHeroLayoutHorizontal'>
              {items &&
                items.map((itemObj, index) => {
                  if (index === 0) {
                    return <Link href={itemObj.wu} key={'2_' + index}  target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} className='ThemeTwoWebHeroLayoutHorizontalCardWrapSlide'>
                    <div className='ThemeTwoWebHeroLayoutHorizontalCardWrap'>
                      <div className='ThemeTwoWebHeroLayoutHorizontalCarContentWrap'>
                        <p className='HeroLayoutHorizontalDiscription' style={{color:props.cardTextColor}}>{itemObj.hl}</p>
                        <div className='horizaltalAuthWrapper'>
                      <div className='themeTwodateAgencyWrap'>
                           <p className='HeroLayoutHorizontalDateTime commonListViewAuth'>{convertEpochTime(itemObj.lpt, 'updated', "DD MMM YYYY")}</p>
                          {(itemObj.au !== '' && props.showAuthor ) && <p className='themeTwoHeroLayoutHorizontalDateTimeAgency commonListViewAuth'>By <span className='manageAuthorName'>{itemObj.au}</span></p>}
                        </div>
                      </div>
                        <div className='themeTwoHeroLayoutHorizontalsSumWrap'>
                          <p className='themeTwoHeroLayoutHorizontalsSummry' style={{color:props.cardTextColor}}>{itemObj.syn}</p>
                        </div>
                      </div>
                      <div className='ThemeTwoWebHeroLayoutHorizontalCardImgWrap'>
                        <img src={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 265, undefined, "", false, props.CONSTANTS)} />
                      </div>
                    </div>
                  </Link>
                  }
                  else {
                    return <Link href={itemObj.wu} key={'other_' + index}  target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} className='ThemeTwoWebHeroLayoutHorizontalCardWrapSlide'>
                      <div className='ThemeTwoWebHeroLayoutHorizontalCardWrap'>
                        <div className='ThemeTwoWebHeroLayoutHorizontalCarContentWrap'>
                          <p className='HeroLayoutHorizontalDiscription' style={{color:props.cardTextColor}}>{itemObj.hl}</p>
                          <div className='horizaltalAuthWrapper'>
                        <div className='themeTwodateAgencyWrap'>
                            <p className='HeroLayoutHorizontalDateTime commonListViewAuth'>{convertEpochTime(itemObj.lpt, 'updated', "DD MMM YYYY")}</p>
                            {(itemObj.au !== '' && props.showAuthor) && <p className='themeTwoHeroLayoutHorizontalDateTimeAgency commonListViewAuth'>By <span>{itemObj.au}</span></p>}
                          </div>
                        </div>
                          <div className='themeTwoHeroLayoutHorizontalsSumWrap'>
                            <p className='themeTwoHeroLayoutHorizontalsSummry' style={{color:props.cardTextColor}}>{itemObj.syn}</p>
                          </div>
                        </div>
                        <div className='ThemeTwoWebHeroLayoutHorizontalCardImgWrap'>
                          <img src={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 265, undefined, "", false, props.CONSTANTS)} />
                        </div>
                      </div>
{/* 
                      <div className='horizaltalAuthWrapper'>
                        <div className='themeTwodateAgencyWrap'>
                            <p className='HeroLayoutHorizontalDateTime commonListViewAuth'>{convertEpochTime(itemObj.lpt, 'updated', "DD MMM YYYY")}</p>
                            {(itemObj.au !== '' && props.showAuthor) && <p className='themeTwoHeroLayoutHorizontalDateTimeAgency commonListViewAuth'>By <span>{itemObj.au}</span></p>}
                          </div>
                        </div> */}
                    </Link>
                  }
                }
                )}
            </div>
          </Grid>
        </div>
      </div>
    </CacheProvider>
  }
  return (
    <>
      {getRenderPart()}
    </>
  );
}




